import { Transform } from 'class-transformer';
import {
  CreateDateColumn,
  DeleteDateColumn,
  Index,
  PrimaryGeneratedColumn,
  UpdateDateColumn,
} from 'typeorm';

import { ApiProperty } from '../../codegen';
import { IsDate, IsNumber, IsOptional } from '../../validators';

export class BasicEntityWithoutId {
  @ApiProperty()
  @IsDate()
  @CreateDateColumn({ type: 'timestamptz', precision: 3 })
  createdAt!: Date;

  @ApiProperty()
  @IsDate()
  @IsOptional()
  @UpdateDateColumn({ type: 'timestamptz', precision: 3 })
  @Transform(({ value }) => new Date(value))
  @Index()
  updatedAt!: Date;

  @ApiProperty()
  @IsDate()
  @IsOptional()
  @DeleteDateColumn({ type: 'timestamptz', precision: 3 })
  @Transform(({ value }) => (value ? new Date(value) : null))
  deletedAt?: Date;
}

export class BasicEntity extends BasicEntityWithoutId {
  @ApiProperty()
  @IsNumber()
  @PrimaryGeneratedColumn()
  id: number;
}
